import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

export const DialogContentStyled = styled(DialogContent)(() => ({
  padding: '16px 0 65px 0'
}));
